<template>
  <div class="d-flex align-items-center">
    <agregar-booking-planificado-modal />
    <late-arrivals-modal />
  </div>
</template>

<script>
  import AgregarBookingPlanificadoModal from "../modals/lineas/booking/AgregarBookingPlanificadoModal";
  import LateArrivalsModal from "../modals/lineas/booking/LateArrivalsModal";

  export default {

    components: {
      AgregarBookingPlanificadoModal,
      LateArrivalsModal,
    },

  };
</script>

<style></style>
